const FEATURE_HELP_URLS = {
  agent_bots: 'https://mango.nurie.ai/hc/agent-bots',
  agents: 'https://mango.nurie.ai/hc/agents',
  audit_logs: 'https://mango.nurie.ai/hc/audit-logs',
  campaigns: 'https://mango.nurie.ai/hc/campaigns',
  canned_responses: 'https://mango.nurie.ai/hc/canned',
  channel_email: 'https://mango.nurie.ai/hc/email',
  channel_facebook: 'https://mango.nurie.ai/hc/fb',
  custom_attributes: 'https://mango.nurie.ai/hc/custom-attributes',
  dashboard_apps: 'https://mango.nurie.ai/hc/dashboard-apps',
  help_center: 'https://mango.nurie.ai/hc/help-center',
  inboxes: 'https://mango.nurie.ai/hc/inboxes',
  integrations: 'https://mango.nurie.ai/hc/integrations',
  labels: 'https://mango.nurie.ai/hc/labels',
  macros: 'https://mango.nurie.ai/hc/macros',
  reports: 'https://mango.nurie.ai/hc/reports',
  team_management: 'https://mango.nurie.ai/hc/teams',
  webhook: 'https://mango.nurie.ai/hc/webhooks',
  billing: 'https://mango.nurie.ai/pricing',
  saml: 'https://mango.nurie.ai/hc/saml',
  wizard_billing: 'https://mango.nurie.ai/hc/wizard_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
